import {
    GET_CMS_MAIN_NAV_BAR
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;    
    switch (type) {        
        case GET_CMS_MAIN_NAV_BAR:
            return {
                ...state,
                contentNavbar: payload.data
            }
        default:
            return state;
    }
};

export default cmsReducer;